<template>
  <el-dialog title="请完成工作流配置" class="addDialog" :visible.sync="Visible" width="900px" :show-close="true"
             :close-on-press-escape="false" :close-on-click-modal="false">
    <div class="content-inner">
      <div class="l-inner">
        <div class="item" v-if="scenarioName == '智能客服'">
          <div class="label-inner">AI客服模块工作流API秘钥：</div>
          <el-input v-model="Form.aikefu"></el-input>
        </div>
        <div class="item" v-if="scenarioName == '训练智能体'">
          <div class="label-inner">AI提问模块工作流API秘钥：</div>
          <el-input v-model="Form.aitiwen"></el-input>
        </div>
        <div class="item" v-if="scenarioName == '训练智能体'">
          <div class="label-inner">AI计分模块工作流API秘钥：</div>
          <el-input v-model="Form.aijifen"></el-input>
        </div>
        <div class="item">
          <p>（工作流API秘钥通过dygpt-工作流-发布渠道获取）</p>
        </div>
      </div>
    </div>
    <div class="footer-inner" slot="footer">
      <el-button type="primary" size="small" @click="handleSave">保 存</el-button>
      <el-button type="danger" size="small" @click="handleUse">应 用</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Alert } from 'element-ui'
export default {
  name: 'creatDialog',
  props: {
    scenarioName () {
      return {
        type: String,
        default: ''
      }
    }
  },
  data () {
    return {
      Visible: false,
      Form: {
        aikefu: '',
        aitiwen: '',
        aijifen: ''
      },
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
    // this.Form.aikefu = sessionStorage.getItem('znkf_key') || ''
    // this.Form.aitiwen = sessionStorage.getItem('xlznt_tw_key') || ''
    // this.Form.aijifen = sessionStorage.getItem('xlznt_jf_key') || ''
    this.Form.aikefu = sessionStorage.getItem('znkf_key_save') || ''
    this.Form.aitiwen = sessionStorage.getItem('xlznt_tw_key_save') || ''
    this.Form.aijifen = sessionStorage.getItem('xlznt_jf_key_save') || ''
  },
  mounted () {

  },
  methods: {
    // 跳转：
    show () {
      this.Visible = true
    },

    // 验证表单 mode 1:保存  2.应用
    verify (mode) {
      if (mode == 1) {
        if (!this.Form.aitiwen) {
          this.$message.warning('请输入AI提问模块工作流API秘钥！')
          return
        }
        return true
      } else {
        if (!this.Form.aitiwen) {
          this.$message.warning('请输入AI提问模块工作流API秘钥！')
          return
        } if (!this.Form.aijifen) {
          this.$message.warning('请输入AI积分模块工作流API秘钥！')
          return
        }
        return true
      }
    },

    //保存
    handleSave () {
      if (this.scenarioName == '智能客服') {
        if (!this.Form.aikefu) {
          this.$message.warning('请输入AI客服模块工作流API秘钥！')
          return
        }
        // sessionStorage.setItem('znkf_key', this.Form.aikefu)
        sessionStorage.setItem('znkf_key_save', this.Form.aikefu)
        this.$message.success('保存成功')
        setTimeout(() => {
          this.Visible = false
        }, 800);
      } else {
        if (this.verify(1)) {
          // sessionStorage.setItem('xlznt_tw_key', this.Form.aitiwen)
          // sessionStorage.setItem('xlznt_jf_key', this.Form.aijifen)
          sessionStorage.setItem('xlznt_tw_key_save', this.Form.aitiwen)
          sessionStorage.setItem('xlznt_jf_key_save', this.Form.aijifen)
          this.$message.success('保存成功')
          setTimeout(() => {
            this.Visible = false
          }, 800);
        }
      }
    },

    //应用 存在一个逻辑，如果进来是 训练智能体案例时，点击应用时，会自动调用 提问接口
    // handleUse () {
    //   if (this.scenarioName == '智能客服') {
    //     if (!this.Form.aikefu) {
    //       this.$message.warning('请输入AI客服模块工作流API秘钥！')
    //       return
    //     }
    //     sessionStorage.setItem('znkf_key', this.Form.aikefu)
    //     this.$message.success('应用成功')
    //     setTimeout(() => {
    //       this.Visible = false
    //       //应用成功后，清空客服问答列表
    //       this.$emit('cleanznkfMsglist')
    //     }, 800);
    //   } else {
    //     if (this.verify(2)) {
    //       sessionStorage.setItem('xlznt_tw_key', this.Form.aitiwen)
    //       sessionStorage.setItem('xlznt_jf_key', this.Form.aijifen)
    //       this.$message.success('应用成功')
    //       setTimeout(() => {
    //         this.Visible = false
    //         //应用成功后，提取问题
    //         this.$emit('getzntwenti')
    //       }, 800);
    //     }
    //   }
    // },
    handleUse () {
      if (this.scenarioName == '智能客服') {
        if (!this.Form.aikefu) {
          this.$message.warning('请输入AI客服模块工作流API秘钥！')
          return
        }
        // sessionStorage.setItem('znkf_key', this.Form.aikefu)
        let znkf_key_save = sessionStorage.getItem('znkf_key_save')
        if (znkf_key_save != window.CJTY_AIwenda_token) {
          // alert('更新了token1')
          sessionStorage.setItem('znkf_key', this.Form.aikefu)
        }
        this.$message.success('应用成功')
        setTimeout(() => {
          this.Visible = false
          //应用成功后，清空客服问答列表
          this.$emit('cleanznkfMsglist')
        }, 800);
      } else {
        if (this.verify(2)) {
          // sessionStorage.setItem('xlznt_tw_key', this.Form.aitiwen)
          // sessionStorage.setItem('xlznt_jf_key', this.Form.aijifen)
          let xlznt_tw_key_save = sessionStorage.getItem('xlznt_jf_key_save')
          let xlznt_jf_key_save = sessionStorage.getItem('xlznt_jf_key_save')
          if (xlznt_tw_key_save != window.CJTY_AIwenda_token) {
            // alert('更新了token2')
            sessionStorage.setItem('xlznt_tw_key', this.Form.aitiwen)
          }
          if (xlznt_jf_key_save != window.CJTY_AIjifen_token) {
            // alert('更新了token3')
            sessionStorage.setItem('xlznt_jf_key', this.Form.aijifen)
          }
          this.$message.success('应用成功')
          setTimeout(() => {
            this.Visible = false
            //应用成功后，提取问题
            this.$emit('getzntwenti')
          }, 800);
        }
      }
    },
  }
}
</script>

<style lang="less" scoped>
.addDialog {
  backdrop-filter: blur(5px);

  /deep/ .el-dialog {
    border: 1px solid rgba(29, 156, 181, 0.3);
    padding: 0 20px;
    border-radius: 10px;
    background-color: #fff;

    .el-dialog__headerbtn {
      font-size: 20px !important;
    }
  }

  .content-inner {
    height: 500px;

    .label-inner {
      color: #fff;
      margin-bottom: 12px;
      font-size: 15px;
      user-select: none;
    }

    .l-inner {
      // float: left;
      // width: 53%;
      // margin-right: 30px;
      width: 100%;
    }

    .item {
      margin-bottom: 30px;

      /deep/ textarea {
        resize: none;
      }

      .play-icon {
        margin-left: 15px;
        cursor: pointer;
        color: #0f99cb;

        &::before {
          font-size: 20px;
          margin-right: 2px;
          vertical-align: middle;
        }

        &:hover {
          color: #1e589f;
        }
      }
    }

  }

  .footer-inner {
    text-align: center;

    .el-button {
      min-width: 120px;
      letter-spacing: 2px;
    }
  }
}
</style>